import {Button, DialogActions, DialogContent} from '@material-ui/core';
import React from 'react';
import {useDispatch} from 'react-redux';
import Modal from 'Shared/components/Modal';
import {deletePreregistration, PreregisteredUserFilter} from 'Users/ducks/userAdministration';

type DeletePendingRegistrationConfirmationModalProps = {
  onClose: () => void;
  id: string;
  filter: PreregisteredUserFilter;
  encryptedIdentifier?: string;
};

const DeletePendingRegistrationConfirmationModal = ({
  onClose,
  id,
  filter,
  encryptedIdentifier,
}: DeletePendingRegistrationConfirmationModalProps) => {
  const dispatch = useDispatch();

  return (
    <Modal title="Delete Pending Registration" open onClose={onClose}>
      <div className="card__dialog">
        <DialogContent>Delete Pending Registration</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              dispatch(deletePreregistration(id, filter, encryptedIdentifier));
              onClose();
            }}
            color="primary"
          >
            Delete
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </DialogActions>
      </div>
    </Modal>
  );
};

export default DeletePendingRegistrationConfirmationModal;
